export default {
  // only one video track can be published at the same time
  filterVideoTrack() {
    this.localTracks = this.localTracks.filter(item => item.trackMediaType !== 'video');

    if (!this.constraints.screen) {
      // Extension path: always use localVideoTrack (processor is piped inline)
      // Fallback path: use localVbackgroundTrack when blur is active
      const track = (!this.vbProcessorReady && this.videoEffect !== 'none' && this.localVbackgroundTrack)
        ? this.localVbackgroundTrack
        : this.localVideoTrack;

      // Skip when the track is null (e.g. camera off) to avoid a failed publish.
      if (track) {
        this.localTracks.push(track);
      }
    }
  }
}
